<template>
  <div>
    <v-form v-model="form_valido" lazy-validation ref="formulario">
      <z-dialogo 
        ref="dialogo" 
        largura="500px" 
        titulo="Grupo" 
        dividers 
        persistent
        altura="300px"
        scrollable
        @abrir="$refs.formulario.resetValidation()"
      >
        <template #prepend>
          <div class="pa-4 pb-0">
            <v-row dense>
              <!-- <v-col cols="3">
                <z-text-field v-model="grupo.codigo" ref="descricao" label="Código" :rules="[regras.campoObrigatorio]"></z-text-field>
              </v-col> -->
              <v-col cols="12">
                <z-text-field
                  fieldupper
                  v-model="grupo.descricao"
                  ref="descricao"
                  label="Descrição"
                  autofocus
                  upper
                  :rules="[regras.campoObrigatorio]"
                ></z-text-field>
              </v-col>
            </v-row>
          </div>
        </template>

        <template late v-slot:conteudo v-if="hasSubGroups && grupo.id != null">

          <h3 class="text-body-2 mb-3 text--primary">SubGrupos</h3>
          <v-data-table 
            mobile-breakpoint="0" 
            disabled-pagination 
            hide-default-footer
            :headers="headers_subgrupos" 
            :items="subgrupos" 
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.descricao }}</td>
                <td class="text-center">
                  <v-btn icon @click="editarSubGrupo(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon @click="perguntarExcluirSubGrupo(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>

        </template>

        <template v-if="hasSubGroups && grupo.id != null" v-slot:actions_left>
          <v-btn 
            text 
            color="primary" 
            @click="adicionarSubGrupo"
          >
            <v-icon left>mdi-plus</v-icon>Adicionar SubGrupo 
          </v-btn>
        </template>

        <template v-slot:actions_right>
          <v-btn text @click="$refs.dialogo.fechar()" :disabled="salvando">Cancelar</v-btn>
          <v-btn depressed color="primary" ref="btnConfirmar" @click="confirmar" :loading="salvando" :disabled="!form_valido">Confirmar</v-btn>
        </template>
      </z-dialogo>
    </v-form>

    <v-form v-model="form_valido_subgrupo" lazy-validation ref="formularioSubGrupo">
      <z-dialogo ref="dialogoAdicionarSubGrupo" largura="700px" titulo="SubGrupo" dividers persistent @abrir="$refs.formularioSubGrupo.resetValidation()">
        <template v-slot:conteudo>
          <v-row dense>
            <!-- <v-col cols="3">
              <z-text-field v-model="grupo.codigo" ref="descricao" label="Código" :rules="[regras.campoObrigatorio]"></z-text-field>
            </v-col> -->
            <v-col cols="12">
              <z-text-field 
                v-model="subgrupo.descricao" 
                ref="descricao" 
                autofocus
                label="Descrição"
                upper
                :rules="[regras.campoObrigatorio]"
                @keyup.enter="confirmarSubGrupo"
              ></z-text-field>
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions_right>
          <v-btn text @click="$refs.dialogoAdicionarSubGrupo.fechar()" :disabled="salvando">Cancelar</v-btn>
          <v-btn depressed color="primary" ref="btnConfirmarSubGrupo" @click="confirmarSubGrupo" :loading="salvando" :disabled="!form_valido_subgrupo">Confirmar</v-btn>
        </template>
      </z-dialogo>
    </v-form>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

  import * as regras from '@/app/helpers/validacoes';

  export default {
    name: 'GruposForm',

    props: {
      hasSubGroups: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        headers_subgrupos: [
          { text: 'Descrição', value: 'descricao' },
          { text: 'Opções', value: '', width: '200px', align: 'center', sortable: false },
        ],
        excluindo: false,
        salvando: false,
        form_valido: true,
        form_valido_subgrupo: true,
        regras: { ...regras },
      }
    },

    computed: {
      ...mapState('grupos', ['grupos', 'grupo', 'total_itens', 'subgrupos', 'subgrupo']),

    },

    methods: {
      ...mapMutations(['setTitulo', 'LOADING_OFF']),
      ...mapActions('grupos', [
        'listar', 
        'excluir', 
        'abrir', 
        'atualizar', 
        'salvar', 
        'listarSubGrupos', 
        'excluirSubGrupo', 
        'abrirSubGrupo', 
        'atualizarSubGrupo', 
        'salvarSubGrupo']
      ),

      abrir() {
        this.$refs.dialogo.abrir();
      },

      async confirmar() {
        if (!this.$refs.formulario.validate()) {
          return false;
        }

        try {
          this.salvando = true;

          if (this.grupo.id) {
            await this.atualizar(this.grupo);
          } else {
            await this.salvar(this.grupo);
          }

          this.$refs.dialogo.fechar();
          this.$eventbus.notificar('Grupo salvo com sucesso');
          this.$emit('grupo:salvar', {...this.grupo});
          this.$store.commit('grupos/ZERAR');
        } catch (error) {
          this.$eventbus.notificarErro('Não foi possível salvar esta grupo. Verifique os dados preenchidos.', error);
          throw error;
        } finally {
          this.salvando = false;
        }
      },

      cancelar() {
        this.$store.commit('grupos/ZERAR');
        this.$refs.dialogo.fechar();
        this.$emit('cancelar');
      },

      adicionarSubGrupo() {
        this.$store.commit('grupos/ZERAR_SUBGRUPO');
        this.$refs.dialogoAdicionarSubGrupo.abrir();
      },

      async editarSubGrupo(subgrupo) {
        try {
          await this.abrirSubGrupo(subgrupo.id);
          this.$refs.dialogoAdicionarSubGrupo.abrir();
        } catch (error) {
          console.log(error);
          this.$eventbus.notificar('Não foi possível abrir o subgrupo.');
        } finally {
          this.LOADING_OFF();
        }
      },

      async confirmarSubGrupo() {
        if (!this.$refs.formularioSubGrupo.validate()) {
          return false;
        }

        try {
          this.salvando = true;

          if (this.subgrupo.id) {
            await this.atualizarSubGrupo(this.subgrupo);
          } else {
            this.subgrupo.produto_grupo_id = this.grupo.id;
            await this.salvarSubGrupo(this.subgrupo);
          }

          this.$refs.dialogoAdicionarSubGrupo.fechar();
          this.$eventbus.notificar('Subgrupo salvo com sucesso');
        } catch (error) {
          this.$eventbus.notificarErro('Não foi possível salvar esta subgrupo. Verifique os dados preenchidos.', error);
          throw error;
        } finally {
          this.salvando = false;
        }
      },

      perguntarExcluirSubGrupo(subgrupo) {
        this.$refs.dialogoRemoverSubGrupo.abrir().then(async (response) => {
          if (response == true) {
            try {
              this.excluindo = true;
              await this.excluirSubGrupo(subgrupo.id);
              this.$refs.dialogoRemoverSubGrupo.fechar();
              this.$eventbus.notificar('SubGrupo excluído com sucesso!');
            } catch (error) {
              this.$eventbus.notificar('Não foi possível excluir o subgrupo!');
              throw error;
            } finally {
              this.excluindo = false;
            }
          }
        });
      },
    },

    watch: {
      data(newValue, oldValue) {
        
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>